import { type PlatformEvent } from '../types';

export const makeSessionStartEvent = (
  gameKey: string,
  source: string | undefined
): PlatformEvent => {
  return {
    type: 'session_start',
    user_properties: {},
    event_properties: {
      name: 'session_start',
      source,
      game_key: gameKey,
    },
  };
};
